import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_TOPIC_LIST: string = typeCreatorV2('TopicReducer', 'SetTopic');
export const INSERT_TOPIC: string = typeCreatorV2(
  'TopicReducer',
  'InsertTopic'
);
export const UPDATE_TOPIC: string = typeCreatorV2(
  'TopicReducer',
  'UpdateTopic'
);
export const DELETE_TOPIC: string = typeCreatorV2(
  'TopicReducer',
  'DeleteTopic'
);

// export const UPDATE_DESCRIPTION_TEMPORARY: string = typeCreatorV2(
//   'CategoryListReducer',
//   'UpdateDiscriptionTemporary'
// );
// export const UPDATE_PRODUCT_BASIC_INFO: string = typeCreatorV2(
//   'CategoryListReducer',
//   'UpdateDiscriptionTemporary'
// );
